import Style from './container.module.scss';
import { useNode } from '@craftjs/core';
import { FormContainerComponent } from 'src/features/generalForms/builder/types/Container';
import { LayoutPanel } from 'src/features/generalForms/builder/layout/panels/layoutPanel';

export const RootContainer: FormContainerComponent = ({ children }) => {
  const { connectors, styles, isFirstNode } = useNode((node) => ({
    styles: node.data.custom,
    isFirstNode: node.id === 'ROOT',
  }));

  // The Frame color is now set via CSS to support themes.
  const { ...otherStyles } = styles;
  const { connect, drag } = connectors;

  return (
    <div
      ref={(ref: HTMLDivElement) => connect(drag(ref))}
      className={Style.root}
      data-has-shadow={isFirstNode}
      style={otherStyles}
    >
      {children}
    </div>
  );
};

const RootContainerSettings = () => (
  <>
    <LayoutPanel sections={['ContentLayout', 'Dimension', 'Paddings', 'HorizontalAlignment', 'VerticalAlignment']} />
  </>
);

RootContainer.craft = {
  displayName: 'ROOT',
  rules: { canDrag: () => false },
  related: { settings: RootContainerSettings },
};
